<template>
  <div class="user-wrapper">

    <header-notice class="action"/>
    <a-dropdown>
      <span class="action ant-dropdown-link user-dropdown-menu">
        <a-avatar class="avatar" size="small" :src="avatar()"/>
        <span>{{ nickname() }}&nbsp;&nbsp;{{ '/' }}&nbsp;&nbsp;
        {{ roleid() ==0  ? '测试用户' :  roleid() == 1 ?  '管理员' : '普通用户' }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">

        <a-menu-item key="1" @click="toSetting" v-if="showSetting">
          <a-icon type="setting"/>
          <span>项目设置</span>
        </a-menu-item>

        <a-menu-item key="2" @click="toggle">
          <a-icon type="setting"/>
          <span>主题设置</span>
        </a-menu-item>

        <a-menu-divider/>

        <a-menu-item key="3" @click="toProjects">
          <a-icon type="desktop"/>
          <span>我的项目</span>
        </a-menu-item>

        <a-menu-item key="4" @click="toCenter">
          <a-icon type="user"/>
          <span>个人中心</span>
        </a-menu-item>

        <a-menu-divider/>

        <a-menu-item key="5" @click="handleLogout">
          <a-icon type="logout"/>
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <setting-drawer ref="drawer" />
  </div>
</template>

<script>
import HeaderNotice from './HeaderNotice'
import { mapActions, mapGetters, mapState } from 'vuex'
import SettingDrawer from '@/components/setting/SettingDrawer'

export default {
  name: 'UserMenu',
  components: {
    HeaderNotice,
    SettingDrawer
  },
  data () {
    return {
      showSetting: false
    }
  },
  computed: {
    ...mapState({
      isProjectCreater: state => state.project.isProjectCreater
    })
  },
  watch: {
    isProjectCreater (yes) {
      if (yes) this.showSetting = true
      else this.showSetting = false
    }
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar','roleid']),
    toggle () {
      this.$refs.drawer.toggle()
    },
    handleLogout () {
      const { Logout } = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
          Logout(true) // 不重定向
        },
        onCancel () {
        }
      })
    },
    toSetting () {
      this.$router.push({ name: 'projectsetting' })
    },
    toCenter () {
      this.$store.dispatch('ToHome', { pageName: 'self' })
    },
    toProjects () {
      this.$store.dispatch('ToHome', { pageName: 'projects' })
    }
  }
}
</script>
